import React from 'react';
import { HeadFC, graphql } from 'gatsby';
import { useLocation } from '@reach/router';

import SEO from '../../components/Head';
import WidgetV2 from '../../components/WidgetV2';
import LayoutRaw from '../../components/Layout/Layout';

interface ContextType {
  locale: string;
  name: string;
}

const Provider = () => {
  const { state } = useLocation() as {
    state: { provider: string };
  };

  return (
    <LayoutRaw>
      <WidgetV2 provider={state?.provider} />
    </LayoutRaw>
  );
};

export const Head: HeadFC<Queries.HomeQueryQuery, ContextType> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <SEO
      meta={file?.childJson?.meta || null}
      pathname={location.pathname}
      locale={pageContext.locale}
    />
  );
};

export const query = graphql`
  query WalletQuery($name: String!) {
    file(name: { eq: $name }, relativePath: { glob: "**/home/**" }) {
      childJson {
        ...Meta
      }
    }
  }
`;

export default Provider;
